import React, { useContext, useEffect, useState } from 'react';
import { defaultVehicleDataForm, VehicleDataForm } from '../../../app/models/Vehicle';
import useVehicleService from '../../../app/services/hooks/useVehicleService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import VehicleFormContainer from './VehicleFormContainer';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    vehicleId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const VehicleEdit = ({ vehicleId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingEditVehicle, editVehicle, fetchingUpdateVehicle, updateVehicle } = useVehicleService();

    const [vehicle, setVehicle] = useState<VehicleDataForm>(defaultVehicleDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando vehículo...');
        editVehicle(vehicleId, {
            onSuccess: (response: ServiceResponse) => {
                setVehicle(response.data.vehicle);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando vehículo...');
        updateVehicle(vehicleId, vehicle, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditVehicle ? (
        <LazyLoading height="300" />
    ) : (
        <VehicleFormContainer
            fetching={fetchingUpdateVehicle}
            action={update}
            cancel={cancel}
            vehicle={vehicle}
            setVehicle={setVehicle}
            errorFields={errorFields}
        />
    );
};

export default VehicleEdit;
